import httpClient from './http'

const getChallenge = async (challengeId) => httpClient.get(`/challenge/${challengeId}`)
const getChallenges = async () => httpClient.get('/challenge')

export {
  getChallenge,
  getChallenges
}
